<script>
import { getOnShelfVideos, getFeaturedVideos, getVideosByCategory } from '../../api/video';

export default {
  name: 'VideoList',
  data() {
    return {
      videoList: [],
      featuredVideos: [],
      page: 0,
      pageSize: 12,
      loading: false,
      noMore: false,
      selectedCategory: null,
      searchTitle: '',
      categoryOptions: [
        { label: '全部视频', value: null },
        { label: '操作演示', value: '操作演示' },
        { label: '案例分享', value: '案例分享' },
        { label: '技术讲解', value: '技术讲解' },
        { label: '产品介绍', value: '产品介绍' },
        { label: '客户见证', value: '客户见证' },
        { label: '其他', value: '其他' }
      ]
    }
  },
  methods: {
    async loadFeaturedVideos() {
      try {
        const res = await getFeaturedVideos(6);
        if (res.data && res.data.data) {
          this.featuredVideos = res.data.data;
        }
      } catch (error) {
        console.error('加载精选视频失败', error);
      }
    },

    async getVideosFunc() {
      if (this.loading || this.noMore) return;

      this.loading = true;

      try {
        const params = {
          page: this.page,
          size: this.pageSize
        };
        
        if (this.selectedCategory) {
          params.category = this.selectedCategory;
        }
        
        if (this.searchTitle && this.searchTitle.trim()) {
          params.title = this.searchTitle.trim();
        }

        const res = await getOnShelfVideos(params);

        if (res.data && res.data.data && res.data.data.content) {
          const newData = res.data.data.content;

          if (newData.length < this.pageSize) {
            this.noMore = true;
          }

          if (this.page === 0) {
            this.videoList = newData;
          } else {
            this.videoList = [...this.videoList, ...newData];
          }

          if (newData.length > 0) {
            this.page++;
          }
        } else {
          this.noMore = true;
        }
      } catch (error) {
        console.error('加载失败', error);
      } finally {
        this.loading = false;
      }
    },

    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.getVideosFunc();
      }
    },

    changeCategory(category) {
      this.selectedCategory = category;
      this.page = 0;
      this.noMore = false;
      this.videoList = [];
      this.getVideosFunc();
    },

    handleSearch() {
      this.page = 0;
      this.noMore = false;
      this.videoList = [];
      this.getVideosFunc();
    },

    clearSearch() {
      this.searchTitle = '';
      this.handleSearch();
    },

    openVideoDetail(id) {
      if (this.$router && this.$router.resolve) {
        const routeData = this.$router.resolve({ path: '/video/' + id });
        window.open(routeData.href, '_blank');
      }
    },

    formatDuration(seconds) {
      if (!seconds) return '0:00';
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      } else {
        return `${minutes}:${String(secs).padStart(2, '0')}`;
      }
    },

    formatViewCount(count) {
      if (!count) return '0';
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + '万';
      }
      return count.toString();
    }
  },
  mounted() {
    this.loadFeaturedVideos();
    this.getVideosFunc();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<template>
  <div class="video_wrap">
    <!-- 顶部Banner -->
    <div class="video_banner">
      <div class="banner_content">
        <div class="banner_title">视频中心</div>
        <div class="banner_desc">观看精彩视频，了解更多内容</div>
      </div>
    </div>

    <div class="container">
      <!-- 搜索栏 -->
      <div class="search_bar">
        <el-input
          v-model="searchTitle"
          placeholder="搜索视频标题"
          class="search_input"
          clearable
          @keyup.enter="handleSearch"
          @clear="clearSearch"
        >
          <template #append>
            <el-button @click="handleSearch">搜索</el-button>
          </template>
        </el-input>
      </div>

      <!-- 分类导航 -->
      <div class="category_nav">
        <div
          v-for="item in categoryOptions"
          :key="item.value"
          :class="['category_item', { active: selectedCategory === item.value }]"
          @click="changeCategory(item.value)"
        >
          {{ item.label }}
        </div>
      </div>

      <!-- 精选视频 -->
      <div v-if="featuredVideos.length > 0" class="featured-section">
        <h2 class="section-title">精选视频</h2>
        <div class="video-grid">
          <article class="video-card featured" v-for="item in featuredVideos" :key="item.id" @click="openVideoDetail(item.id)">
            <div class="card-cover">
              <img :src="item.coverImage" :alt="item.title" class="cover-image" />
              <div class="play-overlay">
                <i class="el-icon-video-play play-icon"></i>
              </div>
              <div class="duration-badge">{{ formatDuration(item.duration) }}</div>
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ item.title }}</h3>
              <div class="card-info">
                <span class="info-item" v-if="item.author">
                  <i class="el-icon-user"></i> {{ item.author }}
                </span>
                <span class="info-item" v-if="item.category">
                  <i class="el-icon-folder"></i> {{ item.category }}
                </span>
              </div>
              <div class="card-footer">
                <div class="view-count">
                  <i class="el-icon-view"></i> {{ formatViewCount(item.viewCount) }} 次播放
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>

      <h2 class="section-title">全部视频</h2>

      <!-- 视频网格 -->
      <div class="video-grid">
        <article class="video-card" v-for="item in videoList" :key="item.id" @click="openVideoDetail(item.id)">
          <div class="card-cover">
            <img :src="item.coverImage" :alt="item.title" class="cover-image" />
            <div class="play-overlay">
              <i class="el-icon-video-play play-icon"></i>
            </div>
            <div class="duration-badge">{{ formatDuration(item.duration) }}</div>
          </div>
          <div class="card-content">
            <h3 class="card-title">{{ item.title }}</h3>
            <div class="card-info">
              <span class="info-item" v-if="item.author">
                <i class="el-icon-user"></i> {{ item.author }}
              </span>
              <span class="info-item" v-if="item.category">
                <i class="el-icon-folder"></i> {{ item.category }}
              </span>
            </div>
            <div class="card-footer">
              <div class="view-count">
                <i class="el-icon-view"></i> {{ formatViewCount(item.viewCount) }}
              </div>
            </div>
          </div>
        </article>
      </div>

      <!-- 加载状态 -->
      <div class="footer-status">
        <div v-if="loading" class="loading-box">
          <span class="loading-icon"></span> 努力加载中...
        </div>
        <div v-if="noMore && videoList.length > 0" class="no-more-line">
          <span>已显示全部视频</span>
        </div>
        <div v-if="noMore && videoList.length === 0" class="empty-box">
          暂无视频
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.video_wrap {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
}

.video_banner {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
  }
}

.banner_content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
}

.banner_title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner_desc {
  font-size: 20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.search_bar {
  max-width: 600px;
  margin: 0 auto 30px;
}

.search_input {
  width: 100%;
}

.category_nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.category_item {
  padding: 10px 30px;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
  }

  &.active {
    background: #667eea;
    border-color: #667eea;
    color: #fff;
  }
}

.featured-section {
  margin-bottom: 60px;
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background: #667eea;
    margin: 15px auto 0;
    border-radius: 2px;
  }
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.video-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

    .play-overlay {
      opacity: 1;
    }

    .cover-image {
      transform: scale(1.05);
    }
  }

  &.featured {
    border: 2px solid #667eea;
  }
}

.card-cover {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background: #000;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s;
}

.play-icon {
  font-size: 60px;
  color: #fff;
}

.duration-badge {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.card-content {
  padding: 15px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
  min-height: 44px;
}

.card-info {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #666;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 5px;

  i {
    color: #667eea;
  }
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #999;
}

.view-count,
.like-count {
  display: flex;
  align-items: center;
  gap: 5px;

  i {
    font-size: 14px;
  }
}

.footer-status {
  text-align: center;
  padding: 40px 0;
}

.loading-box {
  font-size: 16px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loading-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid #667eea;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-more-line {
  position: relative;
  font-size: 14px;
  color: #999;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 100px;
    height: 1px;
    background: #e0e0e0;
  }
  
  &::before {
    right: calc(50% + 80px);
  }
  
  &::after {
    left: calc(50% + 80px);
  }
}

.empty-box {
  font-size: 16px;
  color: #999;
  padding: 60px 0;
}

@media (max-width: 768px) {
  .banner_title {
    font-size: 32px;
  }

  .banner_desc {
    font-size: 16px;
  }

  .video-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }

  .category_nav {
    gap: 10px;
  }

  .category_item {
    padding: 8px 20px;
    font-size: 14px;
  }
}
</style>
